<template>
	<v-btn
		color="secondary"
		@click="export_excel"
		v-if="!permission || myPermissions.includes(permission)"
		:style="dark_t?'color:black':''"
		>
		<!--small outlined class="btn-radius"  -->
		<v-icon></v-icon>
		<span>
			<slot>Exportar Excel</slot>
		</span>
	</v-btn>
</template>

<script>
import {parse_filters} from '@/functions/general.js';
export default {
	props: ['custom_name','name', 'config_name','extra_filter','ex_permission'],
	computed:{
    endpoints() { return this.$store.getters.endpoints },
    config_export_name_computed(){ return this.custom_name || `export/${(this.name)}`},
		my_export_config(){ return this.endpoints.find(c => c.rp === this.config_export_name_computed) || {}},
		permission(){ return this.my_export_config.permission || this.ex_permission},

		requestStatus() { return this.$store.getters.requestStatus },
		name_all_computed(){ return this.config_name || `${this.name}/a/all` },
    myRequestStatus() { return this.requestStatus.find(r=>r.name==this.name_all_computed)||{} },
    filter() { return this.myRequestStatus.filter },
	},
  methods: {
		export_excel(){
			const f = {}
			const exclude_f = ['page','page_size','count'];
			const fltrs = Object.assign({},(this.filter||{}),(this.extra_filter||{}))
			this.dev_log({fltrs},this.myRequestStatus,this.name_all_computed,this.config_export_name_computed);
			Object.keys(fltrs).forEach(k => !exclude_f.includes(k) && fltrs[k] != undefined && (f[k] = fltrs[k]));
			const filters = parse_filters(f);
      this.requests.get_export[this.config_export_name_computed](filters);
    },
	},
};
</script>
